import { Injectable } from '@angular/core';

// Import's Services:
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioAnexoIIService {

  constructor( private requestUrlReporte: ReportesRequestService) { }

  public async getBodyReport( codigoBaseDatos: string, uncoAtencionInicialUrgencia: number) {
    try {

      const response = await this.requestUrlReporte.getRequest(
        'anexoII/anexoII-info',
        [ codigoBaseDatos,
            {
              'uncoAtencionInicialUrgencia' : uncoAtencionInicialUrgencia
            }
        ]
      );

      return response;

    } catch (exception) {
      console.error(exception);
    }
  }

}

export interface AnexoIIEntity {
  numeroAtencion: number;
  pacienteMetid: number;
  clasificacionTriagge: number;
  destinoPaciente: number;
  origenAtencion: string;
  nombrePrestadorRemitente: string;
  codigoPrestadorRemitente: string;
  departamentoPrestadorRemitente: string;
  municipioPrestadorRemitente: string;
  motivoConsulta: string;
  codigoPrincipalDx: string;
  descripcionPrincipalDx: string;
  codigoDx1: string;
  descripcionDx1: string;
  codigoDx2: string;
  descripcionDx2: string;
  codigoDx3: string;
  descripcionDx3: string;
  nombreReporta: string;
  telefonoIndicativoReporta: string;
  telefonoExtensionReporta: string;
  celularReporta: string;
  codigoIndicacionPrestador: string;
  codigoPrestador: string;
  direccionPrestador: string;
  telefonoIndicativoPrestador: string;
  telefonoPrestador: string;
  nombrePrestador: string;
  numeroIndicacionPrestador: string;
  digitoVerificacionPrestador: string;
  nombreErp: string;
  codigoErp: string;
  coberturaSalud: string;
  primerApellido: string;
  segundoApellido: string;
  primerNombre: string;
  segundoNombre: string;
  tipoIdentificacionAfiliado: string;
  numeroIdentificacionAfiliado: string;
  direccionAfiliado: string;
  telefonoAfiliado: string;
  telefonoCelularAfiliado: string;
  codigoMunicipioPrestador: string;
  descripcionMunicipioPrestador: string;
  codigoMunicipioAfiliado: string;
  descripcionMunicipioAfiliado: string;
  descripcionDepartamentoAfiliado: string;
  codigoDepartamentoPrestador: string;
  codigoDepartamentoAfiliado: string;
  cargoReporta: string;
  horaInforme: string;
  descripcionDepartamentoPrestador: string;
  horaIngresoUrgencias: string;
  fechaInforme: string;
  fechaIngresoUrgencias: string;
  fechaNacimientoAfiliado: string;
  pacienteRemetido: number;
}
